import { Container, Link, Paper, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import React from 'react'

import { ClassesProps } from '../../core/SharedProps'

const PageFooter: React.FC<React.PropsWithChildren<ClassesProps>> = (props) => {
  const { classes } = props
  return (
    <footer>
      <Container className={classes.root}>
        <Paper className={classes.paper}>
          <Typography variant="body1">
            <strong>Grieg Connect</strong> | Langveien 16, 6509 Kristiansund | Tel: (+47) 464 40 500 | Org.nr.:989 786
            857 | <Link href="https://griegconnect.com/">Grieg Connect AS</Link> is part of{' '}
            <Link href="https://grieglogistics.no/">Grieg Logistics AS</Link>
          </Typography>
        </Paper>
      </Container>
    </footer>
  )
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginTop: '50px',
      marginBottom: '20px',

      '& a': {
        color: '#ddd',
        fontWeight: 'strong',
      },
    },
    paper: {
      color: '#bbb',
      padding: '7px',
      textAlign: 'center',
    },
  })

export default withStyles(styles, { withTheme: true })(PageFooter)
